export enum ResourceType {
  Device = 1,
  Equipment = 2,
  Reader = 3,
  Facility = 4,
  AppUser = 5,
  Relation = 6,
  StockObservation = 7,
  Geofence = 8,
  ReaderLog = 9,
  Task = 10,
  LabelType = 11,
  VisitHistroy = 12,
}

export const resourceTypeToPath = {
  [ResourceType.Device]: '/device',
  [ResourceType.VisitHistroy]: '/visit',
  [ResourceType.Equipment]: '/equipment',
  [ResourceType.Reader]: '/reader',
  [ResourceType.Facility]: '/facility',
  [ResourceType.AppUser]: '/appuser',
};
